// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"Loading_ldsRipple__1JeAu","lds-ripple":"Loading_lds-ripple__3VvlE"};